var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "record s-mb-3"
  }, [_c('div', [_c('div', {
    staticClass: "record__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "record__desc"
  }, [_c('div', {
    staticClass: "record__date"
  }, [_vm._v(_vm._s(_vm.dateLabel) + " " + _vm._s(_vm.date))])])]), _c('div', {
    staticClass: "s-flex s-flex-col s-items-end"
  }, [_vm.showTypeInfo ? _c('p', [_c('span', {
    staticClass: "s-tag"
  }, [_vm._v(_vm._s(_vm.typeText))])]) : _vm._e(), _c('p', {
    staticClass: "s-text-primary",
    class: {
      record__point: !_vm.showTypeInfo
    }
  }, [_c('span', {
    staticClass: "s-font-bold"
  }, [_vm._v(_vm._s(_vm.pointNeedText))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }